(() => {
  if (window.__gearfullVendorPreorderLoaded) return;
  window.__gearfullVendorPreorderLoaded = true;

  const findProductInfo = (sectionId) => {
    const direct = document.getElementById(`MainProduct-${sectionId}`);
    if (direct) return direct;

    return Array.from(document.querySelectorAll('product-info')).find(
      (element) => element.dataset.section === sectionId || element.dataset.originalSection === sectionId
    );
  };

  const findSourceForm = (root, sectionId) =>
    Array.from(root.querySelectorAll('product-form[data-gf-vendor-preorder]')).find(
      (form) => form.dataset.sectionId === sectionId
    ) || root.querySelector('product-form[data-gf-vendor-preorder]');

  const updateAvailabilityText = (productInfo, sourceForm) => {
    if (!productInfo || !sourceForm) return;

    const availabilityText = sourceForm.dataset.gfAvailabilityText;
    const purchaseState = sourceForm.dataset.gfPurchaseState;
    if (!availabilityText) return;

    const renderedSectionId = productInfo.dataset.section || sourceForm.dataset.sectionId;
    const inventory = document.getElementById(`Inventory-${renderedSectionId}`);

    if (inventory) {
      inventory.textContent = availabilityText;
      inventory.dataset.gfPurchaseState = purchaseState || '';
    }

    const availabilityLabel = productInfo.querySelector('.gf-specs dt[data-gf-spec="availability"]');

    if (availabilityLabel?.nextElementSibling) {
      availabilityLabel.nextElementSibling.textContent = availabilityText;
    }
  };

  const syncPurchaseForm = (productInfo, sourceForm) => {
    if (!productInfo || !sourceForm) return;

    const destinationForm = productInfo.querySelector('product-form[data-gf-vendor-preorder]');
    if (!destinationForm) return;

    destinationForm.dataset.gfPurchaseState = sourceForm.dataset.gfPurchaseState || '';
    destinationForm.dataset.gfAvailabilityText = sourceForm.dataset.gfAvailabilityText || '';

    const sourceButton = sourceForm.querySelector('[id^="ProductSubmitButton-"]');
    const destinationButton = destinationForm.querySelector('[id^="ProductSubmitButton-"]');

    if (sourceButton && destinationButton) {
      const disabled = sourceButton.hasAttribute('disabled');
      destinationButton.toggleAttribute('disabled', disabled);

      if (disabled) {
        destinationButton.setAttribute('aria-disabled', 'true');
      } else {
        destinationButton.removeAttribute('aria-disabled');
      }

      const sourceLabel = sourceButton.querySelector('span');
      const destinationLabel = destinationButton.querySelector('span');
      if (sourceLabel && destinationLabel) destinationLabel.textContent = sourceLabel.textContent.trim();
    }

    const destinationVariantInput = destinationForm.querySelector('input[name="id"]');
    if (destinationVariantInput && sourceButton) {
      destinationVariantInput.disabled = sourceButton.hasAttribute('disabled');
    }

    const sourceProperties = sourceForm.querySelector('[id^="VendorPreorderProperties-"]');
    const destinationProperties = destinationForm.querySelector('[id^="VendorPreorderProperties-"]');
    if (sourceProperties && destinationProperties && sourceProperties !== destinationProperties) {
      destinationProperties.innerHTML = sourceProperties.innerHTML;
    }

    updateAvailabilityText(productInfo, sourceForm);
  };

  const syncExistingForms = () => {
    document.querySelectorAll('product-form[data-gf-vendor-preorder]').forEach((form) => {
      const productInfo = form.closest('product-info') || findProductInfo(form.dataset.sectionId);
      syncPurchaseForm(productInfo, form);
    });
  };

  const subscribeToVariantChanges = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data?.html || !data.sectionId) return;

      const sourceForm = findSourceForm(data.html, data.sectionId);
      const productInfo = findProductInfo(data.sectionId);
      syncPurchaseForm(productInfo, sourceForm);
    });
  };

  document.addEventListener('product-info:loaded', (event) => {
    const productInfo = event.target.closest?.('product-info') || event.target;
    const form = productInfo?.querySelector?.('product-form[data-gf-vendor-preorder]');
    syncPurchaseForm(productInfo, form);
  });

  subscribeToVariantChanges();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncExistingForms, { once: true });
  } else {
    syncExistingForms();
  }
})();
